import { createStorage } from "..";

const networkErrorStorage = createStorage({
  prefix: "network_error_",
  type: "local",
});

export { networkErrorStorage };
